<template>
    <div class="d-flex w-100">
      <div class="d-flex w-100">
        <div class="col-md-3">
          <inqueryDetailsInformationQmaPit v-on:Reload="setReload" ref="informationQmaPit" :propQma="propQma"></inqueryDetailsInformationQmaPit>
        </div>
        <div class="col-md-9">
          <inqueryDetailsTableQmaPit :qma="qma" ref="registerTable" :propQma="propQma" :idQma="idQma"></inqueryDetailsTableQmaPit>
        </div>
      </div>
    </div>
  </template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpensezpag/mixins/ExpenseMixin'
import Multiselect from 'vue-multiselect'
import inqueryDetailsInformationQmaPit from '@/views/private/qma/inqueryQma/inqueryQmaPit/components/inqueryQmaPitTable/components/inqueryQmaPitDetails/components/inqueryDetailsInformationQmaPit/inqueryDetailsInformationQmaPit.vue'
import inqueryDetailsTableQmaPit from '@/views/private/qma/inqueryQma/inqueryQmaPit/components/inqueryQmaPitTable/components/inqueryQmaPitDetails/components/inqueryDetailsTableQmaPit/inqueryDetailsTableQmaPit.vue'
import inqueryQmaRepository from '@/shared/http/repositories/business/qmaInquery'
import { loading } from '@/shared/utils/UIHelper'

export default {
  name: 'inqueryQmaPivsDetails',
  components: {Multiselect, inqueryDetailsInformationQmaPit, inqueryDetailsTableQmaPit},
  mixins: [ ActionsForm, ExpenseMixin ],
  data () {
    return {
      idQma: null,
      propQma: [],
      qma: 1
    }
  },
  props: {

  },
  mounted () {
  },
  methods: {
    onLoad () {
      const params = new URLSearchParams(window.location.search)
      params.forEach((value) => {
        this.idQma = value
        this.getQmaSelected(this.idQma)
      })
    },
    getQmaSelected (value) {
      loading.push()
      inqueryQmaRepository.GetQmaSelected(value)
        .then(response => {
          loading.pop()
          this.propQma = response.data
          this.$refs.informationQmaPit.onLoad(this.propQma)
          this.$refs.registerTable.onLoad(this.propQma)
        })
        .catch((err) => {
          loading.pop()
          console.log(err)
        })
    },
    setReload () {
      this.onLoad()
    }
  }
}

</script>

  <style scoped>
  .col-md-3{
  padding-right: 0;
  padding-left: 0;
  }
  </style>



// WEBPACK FOOTER //
// src/views/private/qma/inqueryQma/inqueryQmaPit/components/inqueryQmaPitTable/components/inqueryQmaPitDetails/inqueryQmaPitDetails.vue